module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loginbg"
    }
  }, [_vm._v("  ·\n  "), _c('div', {
    attrs: {
      "id": "ding"
    }
  }, [_c('div', {
    staticClass: "title",
    attrs: {
      "id": "wenzi"
    }
  }, [_vm._v("\n      自提系统\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "title",
    attrs: {
      "id": "zhanghao"
    }
  }, [_vm._v("\n      账号\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "title",
    attrs: {
      "id": "tuichu"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n      【退出】\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "title",
    attrs: {
      "id": "yuyue"
    },
    on: {
      "click": _vm.tiaozhuanyuyue
    }
  }, [_vm._v("\n      预约\n    ")])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "97%",
      "left": "25px",
      "height": "580px",
      "top": "40px"
    },
    attrs: {
      "data": _vm.pageData.rows,
      "size": "mini"
    }
  }, [(false) ? _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "40"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "card",
      "label": "提货卡号",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "80",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "电话",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "地址",
      "width": "190",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "detailAddress",
      "label": "详细地址",
      "width": "190",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderProduct",
      "label": "商品名称",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spec",
      "label": "规格",
      "width": "140",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "numberProduct",
      "label": "数量",
      "width": "80",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appointmentTime",
      "label": "预约时间",
      "width": "140",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "logisticsNumber",
      "label": "物流单号",
      "width": "140",
      "sortable": ""
    }
  }), _vm._v(" "), (false) ? _c('el-table-column', {
    attrs: {
      "prop": "province",
      "label": "省",
      "width": "140",
      "sortable": ""
    }
  }) : _vm._e(), _vm._v(" "), (false) ? _c('el-table-column', {
    attrs: {
      "prop": "city",
      "label": "市",
      "width": "140",
      "sortable": ""
    }
  }) : _vm._e(), _vm._v(" "), (false) ? _c('el-table-column', {
    attrs: {
      "prop": "area",
      "label": "区",
      "width": "140",
      "sortable": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "状态",
      "width": "80",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.state == -1) ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("已取消")]) : _vm._e(), _vm._v(" "), (scope.row.state == 0) ? _c('span', {
          staticStyle: {
            "color": "dodgerblue"
          }
        }, [_vm._v("已预约")]) : _vm._e(), _vm._v(" "), (scope.row.state == 1) ? _c('span', {
          staticStyle: {
            "color": "dodgerblue"
          }
        }, [_vm._v("已受理")]) : _vm._e(), _vm._v(" "), (scope.row.state == 2) ? _c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("已发货")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.state == 2) ? _c('span', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleSelect1(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看")])], 1) : _vm._e(), _vm._v(" "), (scope.row.state == 0) ? _c('span', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_vm._v("取消")])], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "position": "absolute",
      "margin-left": "550px",
      "margin-top": "-10px"
    },
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next, jumper",
      "current-page": _vm.query.page,
      "page-size": 10,
      "total": _vm.pageData.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "left": "250px",
      "width": "1000px"
    },
    attrs: {
      "visible": _vm.selectVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.selectVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.selectdata,
      "label-width": "80px"
    }
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "left": "50px",
      "top": "20px"
    },
    attrs: {
      "src": require("../../assets/组 689.png")
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "height": "5px",
      "margin-top": "-50px",
      "margin-left": "-25px",
      "width": "380px"
    },
    attrs: {
      "prop": "deliverTime"
    }
  }, [_c('el-row', {
    staticStyle: {
      "color": "#bbbbbb"
    }
  }, [_vm._v(_vm._s(_vm.selectdata.deliverTime))])], 1), _vm._v(" "), _c('el-link', {
    staticStyle: {
      "left": "360px",
      "top": "-18px",
      "color": "firebrick",
      "font-size": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.selectLogisticsDetail()
      }
    }
  }, [_vm._v("详情信息")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "width": "380px",
      "margin-top": "-20px"
    },
    attrs: {
      "prop": "detailAddress"
    }
  }, [_c('el-row', {
    staticStyle: {
      "font-size": "10px",
      "color": "#bbbbbb"
    }
  }, [_vm._v(_vm._s(_vm.selectdata.detailAddress))])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "height": "10px",
      "margin-left": "-25px"
    },
    attrs: {
      "prop": "logisticsDate"
    }
  }, [_c('el-row', {
    staticStyle: {
      "color": "firebrick"
    }
  }, [_vm._v(_vm._s(_vm.selectdata.logisticsDate))])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "100px"
    },
    attrs: {
      "prop": "logisticsAddress"
    }
  }, [_c('el-row', {
    staticStyle: {
      "font-size": "10px",
      "line-height": "20px"
    }
  }, [_vm._v(_vm._s(_vm.selectdata.logisticsAddress))])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    },
    attrs: {
      "prop": "number"
    }
  }, [_c('el-row', {
    staticStyle: {
      "font-size": "12px",
      "line-height": "10px",
      "font-weight": "700"
    }
  }, [_vm._v("物流单号：" + _vm._s(_vm.selectdata.number))])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    },
    attrs: {
      "prop": "userName"
    }
  }, [_c('el-row', {
    staticStyle: {
      "font-size": "12px",
      "line-height": "10px",
      "font-weight": "700"
    }
  }, [_vm._v("收件人姓名：" + _vm._s(_vm.selectdata.userName))])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    },
    attrs: {
      "prop": "phone"
    }
  }, [_c('el-row', {
    staticStyle: {
      "font-size": "12px",
      "line-height": "10px",
      "font-weight": "700"
    }
  }, [_vm._v("收件人电话：" + _vm._s(_vm.selectdata.phone))])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    },
    attrs: {
      "prop": "card"
    }
  }, [_c('el-row', {
    staticStyle: {
      "font-size": "12px",
      "line-height": "10px",
      "font-weight": "700"
    }
  }, [_vm._v("提货卡号：" + _vm._s(_vm.selectdata.card))])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    },
    attrs: {
      "prop": "address"
    }
  }, [_c('el-row', {
    staticStyle: {
      "font-size": "12px",
      "line-height": "10px",
      "font-weight": "700"
    }
  }, [_vm._v("地址：" + _vm._s(_vm.selectdata.address))])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    },
    attrs: {
      "prop": "userDetailAddress"
    }
  }, [_c('el-row', {
    staticStyle: {
      "font-size": "12px",
      "line-height": "10px",
      "font-weight": "700"
    }
  }, [_vm._v("详细地址：" + _vm._s(_vm.selectdata.userDetailAddress))])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    },
    attrs: {
      "prop": "orderProduct"
    }
  }, [_c('el-row', {
    staticStyle: {
      "font-size": "12px",
      "line-height": "10px",
      "font-weight": "700"
    }
  }, [_vm._v("商品名称：" + _vm._s(_vm.selectdata.orderProduct))])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    },
    attrs: {
      "prop": "spec"
    }
  }, [_c('el-row', {
    staticStyle: {
      "font-size": "12px",
      "line-height": "10px",
      "font-weight": "700"
    }
  }, [_vm._v("商品规格：" + _vm._s(_vm.selectdata.spec))])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    },
    attrs: {
      "prop": "numberProduct"
    }
  }, [_c('el-row', {
    staticStyle: {
      "font-size": "12px",
      "line-height": "10px",
      "font-weight": "700"
    }
  }, [_vm._v("商品数量：" + _vm._s(_vm.selectdata.numberProduct))])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    },
    attrs: {
      "prop": "deliverTime"
    }
  }, [_c('el-row', {
    staticStyle: {
      "font-size": "12px",
      "line-height": "10px",
      "font-weight": "700"
    }
  }, [_vm._v("发货时间：" + _vm._s(_vm.selectdata.deliverTime))])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "left": "250px",
      "width": "1000px"
    },
    attrs: {
      "visible": _vm.selectLogisticsVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.selectLogisticsVisible = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "height": "470px",
      "overflow-y": "auto"
    },
    attrs: {
      "label-width": "80px"
    }
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "left": "40px",
      "height": "450px"
    },
    attrs: {
      "src": require("../../assets/zhu.jpg")
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "margin-top": "5px"
    }
  }, [(_vm.selectLogisticsData[0]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "1px",
      "color": "firebrick"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[0].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "50px",
      "margin-top": "-10px"
    }
  }, [(_vm.selectLogisticsData[0]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px",
      "color": "firebrick"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[0].status))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    }
  }, [(_vm.selectLogisticsData[1]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "10px",
      "top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[1].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px",
      "margin-top": "-5px"
    }
  }, [(_vm.selectLogisticsData[1]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[1].status))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px",
      "margin-top": "70px"
    }
  }, [(_vm.selectLogisticsData[2]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "10px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[2].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px",
      "margin-top": "10px"
    }
  }, [(_vm.selectLogisticsData[2]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px",
      "margin-top": "-10px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[2].status))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    }
  }, [(_vm.selectLogisticsData[3]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "10px",
      "top": "45px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[3].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    }
  }, [(_vm.selectLogisticsData[3]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px",
      "top": "35px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[3].status))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    }
  }, [(_vm.selectLogisticsData[4]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "10px",
      "top": "60px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[4].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px",
      "margin-top": "-10px"
    }
  }, [(_vm.selectLogisticsData[4]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px",
      "top": "60px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[4].status))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    }
  }, [(_vm.selectLogisticsData[5]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "10px",
      "top": "80px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[5].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px",
      "margin-top": "-10px"
    }
  }, [(_vm.selectLogisticsData[5]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px",
      "top": "80px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[5].status))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    }
  }, [(_vm.selectLogisticsData[6]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "10px",
      "top": "110px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[6].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px",
      "margin-top": "-10px"
    }
  }, [(_vm.selectLogisticsData[6]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px",
      "top": "110px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[6].status))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    }
  }, [(_vm.selectLogisticsData[7]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "10px",
      "top": "140px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[7].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px",
      "margin-top": "-10px"
    }
  }, [(_vm.selectLogisticsData[7]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px",
      "top": "140px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[7].status))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    }
  }, [(_vm.selectLogisticsData[8]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "10px",
      "top": "170px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[8].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px",
      "margin-top": "-10px"
    }
  }, [(_vm.selectLogisticsData[8]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px",
      "top": "170px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[8].status))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    }
  }, [(_vm.selectLogisticsData[9]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "10px",
      "top": "200px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[9].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px",
      "margin-top": "-10px"
    }
  }, [(_vm.selectLogisticsData[9]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px",
      "top": "200px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[9].status))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    }
  }, [(_vm.selectLogisticsData[10]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "10px",
      "top": "230px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[10].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px",
      "margin-top": "-10px"
    }
  }, [(_vm.selectLogisticsData[10]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px",
      "top": "230px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[10].status))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    }
  }, [(_vm.selectLogisticsData[11]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "10px",
      "top": "260px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[11].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px",
      "margin-top": "-10px"
    }
  }, [(_vm.selectLogisticsData[11]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px",
      "top": "260px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[11].status))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    }
  }, [(_vm.selectLogisticsData[12]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "10px",
      "top": "290px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[12].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px",
      "margin-top": "-10px"
    }
  }, [(_vm.selectLogisticsData[12]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px",
      "top": "290px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[12].status))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    }
  }, [(_vm.selectLogisticsData[13]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "10px",
      "top": "320px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[13].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px",
      "margin-top": "-10px"
    }
  }, [(_vm.selectLogisticsData[13]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px",
      "top": "320px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[13].status))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    }
  }, [(_vm.selectLogisticsData[14]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "10px",
      "top": "350px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[14].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px",
      "margin-top": "-10px"
    }
  }, [(_vm.selectLogisticsData[14]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px",
      "top": "350px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[14].status))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    }
  }, [(_vm.selectLogisticsData[15]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "10px",
      "top": "380px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[15].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px",
      "margin-top": "-10px"
    }
  }, [(_vm.selectLogisticsData[15]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px",
      "top": "380px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[15].status))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    }
  }, [(_vm.selectLogisticsData[16]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "10px",
      "top": "410px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[16].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px",
      "margin-top": "-10px"
    }
  }, [(_vm.selectLogisticsData[16]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px",
      "top": "410px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[16].status))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    }
  }, [(_vm.selectLogisticsData[17]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "10px",
      "top": "440px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[17].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px",
      "margin-top": "-10px"
    }
  }, [(_vm.selectLogisticsData[17]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px",
      "top": "440px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[17].status))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    }
  }, [(_vm.selectLogisticsData[18]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "10px",
      "top": "470px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[18].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px",
      "margin-top": "-10px"
    }
  }, [(_vm.selectLogisticsData[18]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px",
      "top": "470px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[18].status))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    }
  }, [(_vm.selectLogisticsData[19]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "10px",
      "top": "500px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[19].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px",
      "margin-top": "-10px"
    }
  }, [(_vm.selectLogisticsData[19]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px",
      "top": "500px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[19].status))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px"
    }
  }, [(_vm.selectLogisticsData[20]) ? _c('el-row', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "10px",
      "top": "530px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[20].time))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-25px",
      "height": "5px",
      "margin-top": "-10px"
    }
  }, [(_vm.selectLogisticsData[20]) ? _c('el-row', {
    staticStyle: {
      "font-size": "8px",
      "line-height": "20px",
      "top": "530px"
    }
  }, [_vm._v(_vm._s(_vm.selectLogisticsData[20].status))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "resform3",
    staticStyle: {
      "display": "none",
      "position": "absolute",
      "left": "450px",
      "top": "20px"
    },
    attrs: {
      "model": _vm.resform3,
      "id": "products1",
      "rules": _vm.rules3,
      "label-width": "100px",
      "close-on-click-modal": false
    }
  }, [_c('div', {
    attrs: {
      "id": "errorimg"
    }
  }, [_c('img', {
    attrs: {
      "id": "error",
      "src": require("../../assets/error.png")
    },
    on: {
      "click": function($event) {
        return _vm.tuichu()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "label": "提货卡卡号:"
    }
  }, [_c('el-row', {
    attrs: {
      "onfocus": "this.blur()"
    }
  }, [_vm._v(_vm._s(this.resform3.card))])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "label": "收件人姓名:",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.resform3.name),
      callback: function($$v) {
        _vm.$set(_vm.resform3, "name", $$v)
      },
      expression: "resform3.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "label": "收件人电话:",
      "prop": "phone"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.resform3.phone),
      callback: function($$v) {
        _vm.$set(_vm.resform3, "phone", $$v)
      },
      expression: "resform3.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "label": "验证码:",
      "prop": "code"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "不修改手机号则不用获取验证码"
    },
    model: {
      value: (_vm.resform3.code),
      callback: function($$v) {
        _vm.$set(_vm.resform3, "code", $$v)
      },
      expression: "resform3.code"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "position": "absolute",
      "left": "323px",
      "top": "6px",
      "width": "100px"
    },
    attrs: {
      "id": "code",
      "type": "primary",
      "size": "mini",
      "disabled": _vm.codeDisabled
    },
    on: {
      "click": _vm.sendCode
    }
  }, [_vm._v(_vm._s(_vm.codeMsg))])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "label": "地址:",
      "prop": "address"
    }
  }, [_c('v-distpicker', {
    attrs: {
      "province": _vm.resform3.province,
      "city": _vm.resform3.city,
      "area": _vm.resform3.area
    },
    on: {
      "province": _vm.provinceChange,
      "city": _vm.cityChange,
      "area": _vm.areaChange
    },
    model: {
      value: (_vm.resform3.address),
      callback: function($$v) {
        _vm.$set(_vm.resform3, "address", $$v)
      },
      expression: "resform3.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "label": "详细地址:",
      "prop": "detailAddress"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.resform3.detailAddress),
      callback: function($$v) {
        _vm.$set(_vm.resform3, "detailAddress", $$v)
      },
      expression: "resform3.detailAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "label": "发货时间:",
      "prop": "appointmentTime"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.resform3.appointmentTime),
      callback: function($$v) {
        _vm.$set(_vm.resform3, "appointmentTime", $$v)
      },
      expression: "resform3.appointmentTime"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%",
      "margin-left": "-30px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.resLoading
    },
    on: {
      "click": _vm.reservationUpdate
    }
  }, [_vm._v("确定")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#eaeaea",
      "width": "570px",
      "height": "65px",
      "border-radius": "7px"
    }
  }, [_c('div', {
    staticStyle: {
      "top": "645px",
      "width": "500px",
      "margin-left": "40px"
    }
  }, [_vm._v("\n        提示：快递公司收件后正常情况下可以当天发出。一般快递公司正常每天装包发车的时间为下午四点，在装包发车时间之前被快递员收取的快递，当天都可以正常发出。请用户合理安排时间。\n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-673a8ca2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/cdwgkj/UserReservationOrder.vue
// module id = 599
// module chunks = 1